import { useContext, useState } from 'react';
import { store } from 'components/Store';
import AddEngagementStatsToReportModal from 'components/Dashboard/Influence/CrmEngagementStats/ui/AddEngagementStatsToReportModal';
import EngagementStatsDownloadModal from 'components/Dashboard/Influence/CrmEngagementStats/ui/EngagementStatsDownloadModal';

// Mirrors GraphActions.jsx's own pattern: the Engagement Stats page (a different branch of the
// component tree to this subnav) publishes what these buttons need into global state - the chart
// section ref and its current legend keys for the download, and its filter state for "Add to
// report" - rather than these buttons reaching into a page they aren't a child of.
const EngagementStatsSubNavActions = () => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { chartSectionRef, localState, chartKeys } = state?.engagementStatsChartState ?? {};
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);

  if (!localState) return null;

  return (
    <div className='chart-action-buttons flex-centered graph-actions-buttons'>
      <button
        className='general-button print-chart-button border text-center'
        onClick={() => setIsDownloadModalOpen(true)}
      >
        <span className='icon-download paragraph-p2' />{' '}
        <span className='ml-2 d-none d-lg-inline-block button-text nowrap-item'>Download chart</span>
      </button>
      <button
        className='general-button print-chart-button border text-center ml-3'
        onClick={() => setIsReportModalOpen(true)}
      >
        <span className='icon-briefing-material paragraph-p2' />{' '}
        <span className='ml-2 d-none d-lg-inline-block button-text nowrap-item'>Add to report</span>
      </button>
      <AddEngagementStatsToReportModal isOpen={isReportModalOpen} setIsOpen={setIsReportModalOpen} localState={localState} />
      <EngagementStatsDownloadModal
        isOpen={isDownloadModalOpen}
        setIsOpen={setIsDownloadModalOpen}
        chartSection={chartSectionRef}
        chartKeys={chartKeys}
        localState={localState}
      />
    </div>
  );
};

export default EngagementStatsSubNavActions;
